<template>
  <div>
    <v-snackbar v-model="alertSuccessMessage" :timeout="timeout" top color="success">
      <span class="d-flex justify-center">
        {{ successMessage }}
      </span>
    </v-snackbar>
    <v-snackbar
      :value="loadingApp===1"
      centered
      elevation="0"
      color="transparent"
      timeout=-1
    >
      <div class="d-flex justify-center">
        <v-progress-circular
          indeterminate
          color="ppc_pink"
          :value="loadingApp"
          :width="5"
        >
        </v-progress-circular>
      </div>
    </v-snackbar>
    <v-snackbar v-model="loadingAppProgress" :timeout="-1" centered color="transparent" elevation="0">
      <div class="d-flex justify-center">
        <v-progress-linear
          v-model="progressUpload"
          buffer-value="0"
          stream
          color="ppc_pink"
          height="3"
          reactive
        ></v-progress-linear>
      </div>
    </v-snackbar>
    <v-snackbar v-model="showProgressBar" timeout=-1 top color="success">
      <v-progress-linear
        v-model="progressUpload"
        color="ppc_grey"
        height="15"
        reactive
      >
      </v-progress-linear>
    </v-snackbar>
    <nav>
      <v-app-bar flat clipped-left app>
        <v-toolbar-title>
          <v-btn class="text-uppercase ppc_darkgreen--text" href="https://proyectoperucentre.org">
            <span class="font-weight-light d-none d-md-inline display-1">Proyecto</span>
            <span class="d-none d-md-inline display-1">Peru</span>
            <span class="font-weight-bold d-flex d-md-none larger--text display-2">P</span>
            <v-card flat class="text-caption mt-3 ml-4">v{{ $store.state.version }}</v-card>
          </v-btn>
          
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn 
          v-if="this.$route.name === 'Invoice'"
          color="ppc_darkgreen"
          class="white--text d-none d-sm-flex"
          @click="$router.go(-1)"
        >
          Back
        </v-btn>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <v-snackbar v-model="alertLoggedOut" :timeout="timeout" top color="success">
          You are signed out, goodbye!
        </v-snackbar>
        <v-snackbar v-model="alertLoggedIn" :timeout="timeout" top color="success">
          Welcome {{lead.first_name}}!
        </v-snackbar>
        <v-spacer></v-spacer>
        <div v-if="!statusLoggedIn">
          <span class="mx-5">
            <span class="font-weight-light d-none d-sm-inline">Sign In</span>
            <v-btn 
              icon 
              color="font-weight-light" 
              @click="dialogSignIn"
              :disabled="loadingAppProgress"
            >
              <v-icon>mdi-login-variant</v-icon>
            </v-btn>
          </span>
        </div>
        <div v-if="statusLoggedIn">
          <span class="mx-5">
            <span class="font-weight-light d-none d-sm-inline">Sign Out</span>
            <v-btn icon color="font-weight-light" @click="onSignOut">
              <v-icon>mdi-logout-variant</v-icon>
            </v-btn>
          </span>
        </div>
      </v-app-bar>
    </nav>
    <v-dialog 
      v-model="dialog_sign_up"
      :retain-focus="false"
      max-width="320px"
    >
      <v-flex>
        <v-card>
          <v-card-title>
            Sign Up
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form @submit.prevent="onSignup">
                <v-flex>
                  <v-text-field
                    name="firstName"
                    label="First name"
                    id="firstName"
                    v-model="first_name"
                    type="text"
                    filled
                    rounded
                    dense
                  >
                  </v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    name="lastName"
                    label="Last name"
                    id="lastName"
                    v-model="last_name"
                    type="text"
                    filled
                    rounded
                    dense
                  >
                  </v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    name="email"
                    label="Email"
                    id="email"
                    v-model="email"
                    type="email"
                    :error-messages="errorMessageEmail"
                    filled
                    rounded
                    dense
                  >
                  </v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    name="password"
                    label="Password"
                    id="password"
                    v-model="password"
                    filled
                    rounded
                    dense
                    :error-messages="errorMessagePassword"
                    :type="passwordField ? 'password' : 'text'"
                    :append-icon="passwordField ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="() => (passwordField = !passwordField)"
                    @blur="matchPassword"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    name="confirmPassword"
                    label="Confirm Password"
                    id="confirmPassword"
                    v-model="confirmPassword"
                    filled
                    rounded
                    dense
                    :error-messages="errorMessageConfirmPassword"
                    :type="confirmedPasswordField ? 'password' : 'text'"
                    :append-icon="confirmedPasswordField ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="() => (confirmedPasswordField = !confirmedPasswordField)"
                    @blur="matchPassword"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex d-flex justify-center>
                  <v-btn type="submit" :disabled="loadingUser" :loading="loadingUser" color="ppc_darkgreen  white--text">
                    Sign up
                    <span slot="loader" class="custom-loader">
                      <v-icon light>mdi-cached</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
                <v-flex mt-11 d-flex  justify-center>
                  <p>Already registered?</p>
                </v-flex>
                <v-flex mb-7 d-flex  justify-center>
                  <v-btn  @click="dialogSignIn" small>
                    Sign in here!
                  </v-btn>
                </v-flex>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-dialog>
    
    <v-dialog 
      v-model="dialog_sign_in"
      :retain-focus="false"
      max-width="320px"
    >
      <v-flex>
        <v-card>
          <v-card-title>
            Sign In
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form @submit.prevent="onSignin">
                <v-flex mt-3>
                  <v-text-field
                    name="email"
                    label="Email"
                    id="email"
                    v-model="email"
                    type="email"
                    :error-messages="errorMessageEmail"
                    filled
                    rounded
                    dense
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    name="password"
                    label="Password"
                    id="password"
                    v-model="password"
                    filled
                    rounded
                    dense
                    :error-messages="errorMessagePassword"
                    :type="passwordFieldSignIn ? 'password' : 'text'"
                    :append-icon="passwordFieldSignIn ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="() => (passwordFieldSignIn = !passwordFieldSignIn)"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex d-flex justify-center>
                  <v-btn type="submit" :disabled="loadingUser" :loading="loadingUser" color="ppc_darkgreen white--text">
                    Sign in
                    <span slot="loader" class="custom-loader">
                      <v-icon light>mdi-cached</v-icon>
                    </span>
                  </v-btn>
                </v-flex>
                <v-flex mt-5 d-flex  justify-center>
                  <p>OR</p>
                </v-flex>
                <v-flex my-5 d-flex  justify-center>
                  <v-btn @click="socialLogin" :disabled="loadingUser" :loading="loadingUser" width="100%" color="ppc_darkgreen--text">
                    <img alt="Google logo" src="../assets/google-logo.png" height="25px" width="25px">
                    <v-spacer></v-spacer>
                    sign in with Google
                  </v-btn>
                </v-flex>
                <v-flex mt-11 d-flex  justify-center>
                  <p>If you don't have an account yet?</p>
                </v-flex>
                <v-flex mb-11 d-flex  justify-center>
                  <v-btn @click="dialogSignUp" small>
                    Sign up here!
                  </v-btn>
                </v-flex>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-dialog>
  </div>
</template>
<script>

  export default {
    data () {
      return {
        email: '',
        password: '',
        confirmPassword: '',
        dialog_sign_up: false,
        dialog_sign_in: false,
        first_name: "",
        last_name: "",
        passwordField: String,
        passwordFieldSignIn: String,
        confirmedPasswordField: String,
        alertLoggedOut: false,
        alertLoggedIn: false,
        timeout: 3000,
        errorMessagePassword: '',
        errorMessageConfirmPassword: '',
        errorMessageEmail: '',
        alertSuccessMessage: false,
        fileRules: [
          file => !file || file.size < 2e6 || 'File size should be less than 2 MB!'
        ],
      }
    },
    // created() {
    //   console.log(this.$route.name)
    // },
    computed: {
      lead () {
        return this.$store.getters.lead
      },
      openDialog_sign_in () {
        return this.$store.getters.openDialog_sign_in
      },
      statusLoggedIn () {
        return this.$store.getters.statusLoggedIn
      },
      error () {
        return this.$store.getters.error
      },
      loadingUser () {
        return this.$store.getters.loadingUser
      },
      loadingApp () {
        return this.$store.getters.loadingApp
      },
      loadingAppProgress () {
        return this.$store.getters.loadingAppProgress
      },
      progressUpload () {
        return this.$store.getters.progressUpload
      },
      successMessage () {
        return this.$store.getters.successMessage
      },
      displaySuccessMessage () {
        return this.$store.getters.displaySuccessMessage
      },
      showProgressBar () {
        return this.$store.getters.showProgressBar
      },
    },
    watch: {
      statusLoggedIn(newValue, oldValue) {
        console.log('statusLoggedIn changed', newValue, oldValue)
        if (newValue) {
          this.dialog_sign_up = false;
          this.dialog_sign_in = false;
          this.alertLoggedIn = true;
        }
        if (!newValue && oldValue) {
          this.alertLoggedOut = true;
        }
      },
      openDialog_sign_in(newValue, oldValue) {
        console.log('openDialog_sign_in changed', newValue, oldValue)
        if (newValue) {
          this.dialog_sign_in = true;
          this.$store.dispatch('openDialog_sign_in', false)
        }
      },
      error: function() {
        console.log('error',this.$store.getters.error)
        if (this.$store.getters.error === null) {
          this.errorMessageEmail = ''
          this.errorMessagePassword = ''
        } else {
          if (this.$store.getters.error.message.includes('email') || this.$store.getters.error.message.includes('user')) {
            this.errorMessageEmail = this.$store.getters.error.message
          } else {
            this.errorMessagePassword = this.$store.getters.error.message
            console.log('errorMessagePassword',this.errorMessagePassword)
          }
        }
      },
      displaySuccessMessage: function () {
        if (this.successMessage !== "") {
          this.alertSuccessMessage = true;
        }
      },
    },
    methods: {
      matchPassword () {
        if (this.password !== this.confirmPassword && this.password !== '' && this.confirmPassword !== '') {
          this.errorMessageConfirmPassword = 'Password does not match'
        } else {
          this.errorMessageConfirmPassword = ''
        }
      },
      onSignOut () {
        this.$store.dispatch('clearError')
        this.$store.dispatch('signUserOut')
      },
      dialogSignUp () {
        this.$store.dispatch('clearError')
        this.email = "";
        this.password = "";
        this.confirmPassword = "";
        this.errorMessageEmail = ''
        this.errorMessagePassword = ''
        this.dialog_sign_in = false;
        this.dialog_sign_up = true;
      },
      dialogSignIn () {
        this.$store.dispatch('clearError')
        this.email = "";
        this.password = "";
        this.confirmPassword = "";
        this.errorMessageEmail = ''
        this.errorMessagePassword = ''
        this.dialog_sign_up = false;
        this.dialog_sign_in = true;
      },
      onSignin () {
        this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
      },
      socialLogin () {
        this.$store.dispatch('socialLogin')
      },
      async onSignup () {
        this.errorMessageEmail = ''
        this.errorMessagePassword = ''
        if (this.email === '') {
          this.errorMessageEmail = 'please fill in your email'
        } else {
          this.errorMessageEmail = ''
          if (this.password !== this.confirmPassword) {
            this.errorMessageConfirmPassword = 'Password does not match'
          } else {
            this.first_name = this.first_name.trim();
            this.last_name = this.last_name.trim();
            this.email = this.email.trim();
            await this.$store.dispatch('signUserUp', {first_name: this.first_name, last_name: this.last_name, email: this.email, password: this.password})
          }
        }
      },
      print () {
        window.print();
      },
      changeLeadValue: function(column, event) {
        const payload = {
          column: column,
          value: event,
        }
        this.$store.dispatch('changeLeadValue', payload);
      },
    }
  }
</script>